import { DepInjMixin } from '@APP/mixins/dependency';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { rotateYourPhone } from '../icons/icons';
import { DeviceAwareComponent } from './device-aware-component';


type OwnDeps = {};


@customElement('lh-rotate-your-phone')
export class LHRotateYourPhone extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      css`
      .center-screen {
        display: flex;
        justify-content: center;
        align-items: center;
      text-align: center;
      min-height: 90vh;      
      max-height: 100vh;      
    }

    .column{
      flex-direction:column;
    }

    `,
    ];
  };

  static get desktopStyles() {
    return [];
  };
  static get mobileStyles() {
    return [];
  };

  connectedCallback(): void {
    super.connectedCallback();
  }

  renderContent() {
    return html`
    <div class="center-screen column">
    <lh-logo class="rotate-your-phone"></lh-logo>
    ${rotateYourPhone}  
    </div>
    `;
  }
}